export const Logo: React.FC = () => {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path d="M40 0H0V40H40V0Z" fill="#FF7900" />
      <path d="M34.2897 28.57H5.71973V34.28H34.2897V28.57Z" fill="white" />
    </svg>
  );
};
